module.exports = __webpack_public_path__ + "img/Instagram.4c3d347b.svg";